var map = {
	"./de.json": [
		1904,
		75
	],
	"./de_CH.json": [
		1905,
		76
	],
	"./de_DE.json": [
		1906,
		77
	],
	"./en.json": [
		665
	],
	"./en_CA.json": [
		1907,
		1
	],
	"./en_CH.json": [
		1861,
		4
	],
	"./en_GB.json": [
		1908,
		1
	],
	"./en_ZA.json": [
		1862,
		4
	],
	"./fr.json": [
		1909,
		78
	],
	"./fr_CA.json": [
		1910,
		2
	],
	"./fr_CH.json": [
		1911,
		2
	],
	"./it.json": [
		1912,
		79
	],
	"./it_CH.json": [
		1913,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 787;
module.exports = webpackAsyncContext;